// This is a quick and dirty API class that does not extend @/Api.js
// With that in mind, maybe when we get the time we can refactor @/Api.js
// to enable a better, more customizable experience for development of
// third-party resource fetching of things like cloud cannon content

import 'whatwg-fetch'

export default class CloudCannonApi {
  /**
   * Returns a JSON file found at the options.cloudCannonResource location
   * @param {Object} options
   * @param {String} options.cloudCannonResource
   * @param {Object} options.params - any queryParams for the request should there ever be a need
   * @returns {Promise} which resolves to the response body of the request
   */
  getCloudCannonContent = (options = {}) => {
    return this.get(options.cloudCannonResource, options.params)
  };

  get = (uri, queryParams) => {
    let url = this._prepareUrl(uri, queryParams)
    return fetch(url, {
      method: 'GET'
    })
      .then(response => {
        if (response.status === 200) { return response } else { throw new Error(`CloudCannon returned ${response.status} for this page.`) }
      })
      .then(response => response.json())
      .catch(_ => {})
  };

  /**
   * Returns a URL for a remote resource whose host is defined by VUE_APP_CLOUD_CANNON_API_BASE_URL in .env.[mode]
   * @param {String} uri - the resource location
   * @param {Object} queryParams - query parameters to append to the URL
   * @returns {String}
   * @private
   */
  _prepareUrl = (uri, queryParams = {}) => {
    let url = process.env.VUE_APP_CLOUD_CANNON_API_BASE_URL
    url += uri
    Object.keys(queryParams).forEach((key, i) => {
      url += i === 0 ? '?' : '&'
      url += `${key}=${queryParams[key]}`
    })
    return url
  }

  _setDevelopmentHeaders = /* istanbul ignore next */ () => {
    /* dont */

  }
}
